import { useIntl, FormattedMessage } from 'react-intl';

import Link from '@atlaskit/link';
import { Text } from '@atlaskit/primitives';
import SectionMessage from '@atlaskit/section-message';

import { messages } from './messages';

const RESOURCE_LINKS = {
	AtlassianCustomerAgreementLink:
		'https://www.atlassian.com/legal/atlassian-customer-agreement#intro',
	AtlassianPrivacyPolicyLink: 'https://www.atlassian.com/legal/privacy-policy',
};

export const LegalBanner = () => {
	const intl = useIntl();

	return (
		<SectionMessage title={intl.formatMessage(messages.legalTitle)} appearance="discovery">
			<Text>
				<FormattedMessage
					{...messages.legalDescription}
					values={{
						CustomerAgreementLink: (
							<Link href={RESOURCE_LINKS.AtlassianCustomerAgreementLink} target="_blank">
								{intl.formatMessage(messages.atlassianCustomerAgreementLinkText)}
							</Link>
						),
						PrivacyPolicyLink: (
							<Link href={RESOURCE_LINKS.AtlassianPrivacyPolicyLink} target="_blank">
								{intl.formatMessage(messages.atlassianPrivacyPolicyLinkText)}
							</Link>
						),
					}}
				/>
			</Text>
		</SectionMessage>
	);
};
